import i18n from '@/lang/index'
export default {
  name: 'magic-cube',
  label: {
    title: i18n.t('rubik_s_cube'),
    icon: require('@/assets/icon-component-label_MagicCube.png'),
    limit: 100
  },
  sort: 3,
  data: {
    blockList: [],
  }
}
